import React from 'react'
import './styles.css'

export const AuthLayout: React.FC<{ children: any }> = ({ children }) => {
  return (
    <div className="auth-layout">
      <div className="logo-container">
        <img src="/assets/logo.png" alt="Content Email" width={200} />
      </div>
      <div className="auth-layout-content">
        { children }
      </div>
    </div>
  )
}

export const AuthLayoutActions: React.FC<{ children: any }> = ({ children }) => {
  return (
    <div className="auth-layout-actions">
      { children }
    </div>
  )
}

export const AuthLayoutClearFix: React.FC = () => {
  return (
    <div className="auth-action-clearfix"></div>
  )
}
